export default __webpack_public_path__ + "static/media/Image-1.31f7653a.png";